import React, {FC, ReactNode} from 'react';

import {Icon} from '@optimaxdev/icons';
import classNames from 'classnames';

import s from './notification.scss';

type PropsType = {
    type: 'error' | 'warning' | 'info' | 'infoBlack';
    icon: typeof import('*.svg');
    children: ReactNode;
};

/**
 * Component for render notification
 */
export const Notification: FC<PropsType> = ({children, icon, type}) => {
    return (
        <div
            className={classNames(s.wrap, {
                [s.wrapError]: type === 'error',
                [s.wrapInfo]: type === 'info',
                [s.wrapInfoBlack]: type === 'infoBlack',
                [s.wrapWarn]: type === 'warning',
            })}
        >
            <Icon className={s.icon} height={16} icon={icon} width={16} />
            <div>{children}</div>
        </div>
    );
};
